import React from "react";
import Countdown from "react-countdown";
import "./DealCountdown.css";

export default function DealCountdown() {
  const targetDate = new Date();

  const currentDay = targetDate.getDay(); // Sunday = 0

  const daysUntilSunday = currentDay === 0 ? 7 : 7 - currentDay;

  targetDate.setDate(targetDate.getDate() + daysUntilSunday);
  targetDate.setHours(23, 59, 59, 999);

  // console.log(targetDate);

  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div className="countdown-wrapper">
        <h3 className="title">Best Deals of the Week</h3>

        <div className="time-boxes">
          <div className="time-box">
            <span className="number">{days}</span>
            <span className="label">DAYS</span>
          </div>

          <div className="time-box">
            <span className="number">{hours}</span>
            <span className="label">HRS</span>
          </div>

          <div className="time-box">
            <span className="number">{minutes}</span>
            <span className="label">MIN</span>
          </div>

          <div className="time-box">
            <span className="number">{seconds}</span>
            <span className="label">SEC</span>
          </div>
        </div>
      </div>
    );
  };

  return <Countdown date={targetDate} renderer={renderer} />;
}
